import { translation } from '@cue/translations';

export interface ShortDurationUnitLabels {
  days: string;
  hours: string;
  minutes: string;
}

export type ShortDurationTranslate = (key: string) => string;

export function formatDurationMinutesForDisplay(durationMinutes: number, translate: ShortDurationTranslate): string {
  return formatDurationMinutesAsShortText(durationMinutes, {
    days: translate(translation.common.shortDurationUnits.days),
    hours: translate(translation.common.shortDurationUnits.hours),
    minutes: translate(translation.common.shortDurationUnits.minutes),
  });
}

export function formatDurationMinutesAsShortText(durationMinutes: number, units: ShortDurationUnitLabels): string {
  const normalizedDurationMinutes = Math.max(0, Math.trunc(durationMinutes));
  const days = Math.floor(normalizedDurationMinutes / 1440);
  const hours = Math.floor((normalizedDurationMinutes % 1440) / 60);
  const minutes = normalizedDurationMinutes % 60;

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days}${units.days}`);
  }

  if (hours > 0) {
    parts.push(`${hours}${units.hours}`);
  }

  if (minutes > 0 || parts.length === 0) {
    parts.push(`${minutes}${units.minutes}`);
  }

  return parts.join(' ');
}
